import { AppAction } from '@om-fe/store';
import { MatchListStoreModel } from '../../utils/match-list-models';
// TODO: adapt to the new API endpoints
export const LIVE_MATCH_AGGREGATOR_PATH: string = 'live-matches-aggregator-main/:disciplineId/:locationId';
export const LIVE_GROUPS_MATCH_AGGREGATOR_PATH: string = 'live-matches-aggregator-groups/:disciplineId/:locationId';
export const LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH: string = 'live-matches-aggregator-groups-overview/:disciplineId/:locationId';
export const LIVE_MATCH_AGGREGATOR_PATH_BY_CATEGORIES: string = 'live-matches-aggregator-main-by-event-category/:eventCategoryId';
export const LIVE_GROUPS_MATCH_AGGREGATOR_PATH_BY_CATEGORIES: string = 'live-matches-aggregator-groups-by-event-category/:eventCategoryId';
export const LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_BY_CATEGORIES: string = 'live-matches-aggregator-groups-overview-by-event-category/:eventCategoryId';
export const LIVE_MATCH_AGGREGATOR_PATH_ALL_SPORTS: string = 'live-matches-aggregator/all-sports';
export const LIVE_GROUPS_MATCH_AGGREGATOR_PATH_ALL_SPORTS: string = 'live-matches-aggregator-groups/all-sports';
export const LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_ALL_SPORTS: string = 'live-matches-aggregator-groups-overview/all-sports';
export const LIVE_MATCH_AGGREGATOR_PATH_NO_ODDS: string = 'live-matches-aggregator/:disciplineId';
export const LIVE_GROUPS_MATCH_AGGREGATOR_PATH_NO_ODDS: string = 'live-matches-aggregator-groups/:disciplineId';
export const LIVE_GROUPS_OVERVIEW_MATCH_AGGREGATOR_PATH_NO_ODDS: string = 'live-matches-aggregator-groups-overview/:disciplineId';
export const LIVE_ESPORTS_MATCH_AGGREGATOR_PATH: string = 'live-matches-aggregator-main/:locationId';
export const LIVE_GROUPS_OVERVIEW_ESPORTS_MATCH_AGGREGATOR_PATH: string = 'live-matches-aggregator-groups-overview/:locationId';

export const slicePrefix = 'live';
export const ALL_LOCATIONS: string = 'all-locations';

export type LiveMatchListTopicModel = LiveMatchListTopic
    | LiveMatchListTopicByCategory;

export type LiveMatchListNoOddsTopicModel = LiveMatchListAllSportsNoOddsTopic
    | LiveMatchListNoOddsTopic;

export interface LiveMatchListStoreModel extends MatchListStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly disciplineId?: string;
    readonly locationId?: string;
    readonly isDefault?: boolean;
    readonly mainMarketsLimit?: number;
    readonly limit: number;
    readonly totalRecords: number;
    readonly eventCategoryId?: string;
    readonly marketGroupsOverviewNumber?: number;
    readonly marketGroupsOverviewIds?: string;
    readonly isAuthenForTopic?: boolean;
}

export enum LiveMatchListActions {
    SetLoadingData = 'sports:live-match-list:set-loading-data',
    SetFilterData = 'sports:live-match-list:set-match-list-filter-data',
}

export interface LiveMatchListSetLoadingData extends AppAction<LiveMatchListActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingMoreData: boolean;
    };
}

export interface LiveMatchListSetFilterDataAction extends AppAction<LiveMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly limit: number;
        readonly disciplineId: string;
        readonly locationId: string | undefined;
        readonly isDefault: boolean | undefined;
        readonly mainMarketsLimit: number | undefined;
        readonly eventCategoryId: string | undefined;
        readonly isAuthenForTopic?: boolean;
    };
}

export interface LiveGroupsMatchListSetFilterDataAction extends AppAction<LiveMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly limit: number;
        readonly disciplineId: string;
        readonly locationId: string | undefined;
        readonly isDefault: boolean | undefined;
        readonly mainMarketsLimit: number | undefined;
        readonly eventCategoryId: string | undefined;
        readonly marketGroupsOverviewNumber: number | undefined;
        readonly isAuthenForTopic?: boolean;
    };
}

export interface LiveGroupsOverviewMatchListSetFilterDataAction extends AppAction<LiveMatchListActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly limit: number;
        readonly disciplineId: string;
        readonly locationId: string | undefined;
        readonly isDefault: boolean | undefined;
        readonly mainMarketsLimit: number | undefined;
        readonly eventCategoryId: string | undefined;
        readonly marketGroupsOverviewIds: string | undefined;
        readonly isAuthenForTopic?: boolean;
    };
}

export interface LiveMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly nrOfMarkets: number;
        readonly locationId?: string;
        readonly limitNumberOfEvents?: number;
        readonly marketGroupsOverviewNumber?: number;
        readonly marketGroupsOverviewIds?: string;
        readonly isAuthenticated?: boolean;
    };
}

export interface LiveMatchListTopicByCategory {
    readonly path: string;
    readonly params: {
        readonly eventCategoryId?: string;
        readonly nrOfMarkets: number;
        readonly limitNumberOfEvents?: number;
        readonly marketGroupsOverviewNumber?: number;
        readonly marketGroupsOverviewIds?: string;
        readonly isAuthenticated?: boolean;
    };
}

interface LiveMatchListAllSportsNoOddsTopic {
    readonly path: string;
    readonly params: {
        readonly limitNumberOfEvents?: number;
        readonly marketGroupsOverviewNumber?: number;
        readonly marketGroupsOverviewIds?: string;
        readonly isAuthenticated?: boolean;
    };
}

interface LiveMatchListNoOddsTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly limitNumberOfEvents?: number;
        readonly isChildren: boolean;
        readonly marketGroupsOverviewNumber?: number;
        readonly marketGroupsOverviewIds?: string;
        readonly isAuthenticated?: boolean;
    };
}

